import { Box, Flex, HStack, Link, Text } from '@chakra-ui/react';
import { IconMaintenance } from 'central-icons/IconMaintenance';

import styles from './card-sections.module.css';

interface SkillsSectionProps {
  skills: string[];
  isExpanded: boolean;
  onToggleExpanded: () => void;
}

export const SkillsSection = ({
  skills,
  isExpanded,
  onToggleExpanded,
}: SkillsSectionProps) => {
  if (!skills.length) return null;

  const displaySkills = isExpanded ? skills : skills.slice(0, 5);

  return (
    <Flex gap={2} fontSize="sm" align="start" color="text.primary">
      <Box flexShrink={0} mt="4px">
        <IconMaintenance size={16} />
      </Box>
      <HStack spacing={1} flexWrap="wrap">
        <Text>{displaySkills.join(', ')}</Text>
        {skills.length > 5 && (
          <Link
            className={styles.moreLink}
            onClick={(e) => {
              e.stopPropagation();
              onToggleExpanded();
            }}
          >
            {isExpanded ? 'Show Less' : 'More'}
          </Link>
        )}
      </HStack>
    </Flex>
  );
};
